import type { CreateReportRequest, ReportData } from "../types";

interface BuildReportRequestParams {
  clientId: string;
  dateFrom: string;
  dateTo: string;
  forceRegenerate?: boolean;
  csvImportId?: string | null;
}

/**
 * Build a report request without dropping CSV shadow-report context.
 *
 * A Reports page opened from CSV onboarding keeps csvImportId in the URL even
 * when the date range is changed. Every subsequent generation from that page
 * must therefore remain scoped to the same CSV import.
 */
export function buildReportCreateRequest({
  clientId,
  dateFrom,
  dateTo,
  forceRegenerate = false,
  csvImportId,
}: BuildReportRequestParams): CreateReportRequest {
  return {
    client_id: clientId,
    date_from: dateFrom,
    date_to: dateTo,
    ...(forceRegenerate ? { force_regenerate: true } : {}),
    ...(csvImportId
      ? {
          report_type: "full" as const,
          data_source: "csv" as const,
          csv_import_id: csvImportId,
        }
      : {}),
  };
}

/** Only a report created for this exact import may complete the import history. */
export function isMatchingCsvReport(
  report: Pick<ReportData, "data_source" | "csv_import_id">,
  csvImportId: string,
): boolean {
  return report.data_source === "csv" && report.csv_import_id === csvImportId;
}
